const ActionHero = require('./action-hero/script.js');
const ImpactHero = require('./impact-hero/script.js');
const IntroHero = require('./intro-hero/script.js');
const VisionHero = require('./vision-hero/script.js');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-action-hero]', function() {
		new ActionHero(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-intro-hero]', function() {
		new IntroHero(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-vision-hero]', function() {
		new VisionHero(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-impact-hero]', function() {
		new ImpactHero(this, {});
	});
});
